import React, { Component } from 'react'

import ModernCalendar from '../../Home/Mobile/Calendar/Calendar';
import TimeSlider from '../../Duties/Mobile/TimeSlider/TimeSlider';
import Repeat from '../../Duties/Mobile/Repeat/Repeat';
import ColorRadio from '../../Duties/Mobile/ColorRadio/ColorRadio';
import Note from '../../Duties/Mobile/Note/Note';

import './Desktop.css';



import calendar1 from '../../../assets/icons/calendar1.svg';
import clock from '../../../assets/icons/clock.svg';


export default class Desktop extends Component {
  render() {
    const { defaultLocation,
      zoom,
      location,
      float,
      tag,
      title,
      orders,
      repeat,
      repeats,
      selectedDay,
      selectedAlarm,
      selectedColor,
      selectedRepeat,
      note,
      colors,
      openCalendar,
      setOpenCalendar,
      openEvents,
      openFloat,
      openRepeat,
      closeFloat,
      closeRepeat,
      setSelectedDay,
      setColor,
      fillTitle,
      setTag,
      deleteTag,
      handleChange,
      handleChangeZoom, } = this.props;
    return (
      <div className="duties d-flex flex-column">
        <div className="duties__date d-flex">
          <div className="duties__date--item d-flex flex-column">
            <h2>تاریخ یادآوری</h2>
            <div className="duties__date--item__box d-flex" onClick={() => setOpenCalendar()}>
              <img src={calendar1} className="mic" />
              <div className="mobile-float-input__value">
                {selectedDay ? selectedDay : 'انتخاب'}
              </div>
            </div>
          </div>
          <div className="duties__date--item d-flex flex-column">
            <h2>تاریخ یادآوری</h2>
            <div className="duties__date--item__box d-flex" onClick={() => setOpenCalendar()}>
              <img src={calendar1} className="mic" />
              <div className="mobile-float-input__value">
                {selectedDay ? selectedDay : 'انتخاب'}
              </div>
            </div>
          </div>
          {
            openCalendar ?
              <div className="mobile-duty-calendar">
                <div className="mobile-duty-calendar__bottom">
                  <ModernCalendar weekAccess={true} headerAccess={true} swipeAccess={true} selectedDay={selectedDay} setSelectedDay={setSelectedDay} />
                  <div className="mobile-duty-time d-flex flex-column">
                    <div className="d-flex mobile-duty-time__slider">
                      <img src={clock} />
                      <h3>ساعت وظیفه را انتخاب نمایید</h3>
                    </div>
                    <TimeSlider />
                    <button className="mobile-duty-calendar__bottom--button" onClick={() => setOpenCalendar()}>ثبت</button>
                  </div>
                </div>
              </div> : null
          }
        </div>
        <Repeat repeat={repeat} repeats={repeats} closeRepeat={closeRepeat} openRepeat={openRepeat} />
        <ColorRadio colors={colors} setColor={setColor} />
        <Note />

      </div>
    );
  }
}
